module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#00f",
      "opacity": "0",
      "min-height": "100%"
    }
  }, [_c('form', {
    attrs: {
      "action": "https://h5pay.jd.com/jdpay/saveOrder",
      "method": "post",
      "id": "batchForm"
    }
  }, [_c('input', {
    attrs: {
      "type": "button",
      "onclick": "autosubmit()",
      "value": "点这提交"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "version"
    },
    domProps: {
      "value": this.g_jdpayList.version
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "merchant"
    },
    domProps: {
      "value": this.g_jdpayList.merchant
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "device"
    },
    domProps: {
      "value": this.g_jdpayList.device
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "tradeNum"
    },
    domProps: {
      "value": this.g_jdpayList.tradeNum
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "tradeName"
    },
    domProps: {
      "value": this.g_jdpayList.tradeName
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "tradeDesc"
    },
    domProps: {
      "value": this.g_jdpayList.tradeDesc
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "tradeTime"
    },
    domProps: {
      "value": this.g_jdpayList.tradeTime
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "amount"
    },
    domProps: {
      "value": this.g_jdpayList.amount
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currency"
    },
    domProps: {
      "value": this.g_jdpayList.currency
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "note"
    },
    domProps: {
      "value": this.g_jdpayList.note
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "callbackUrl"
    },
    domProps: {
      "value": this.g_jdpayList.callbackUrl
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "notifyUrl"
    },
    domProps: {
      "value": this.g_jdpayList.notifyUrl
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "ip"
    },
    domProps: {
      "value": this.g_jdpayList.ip
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "userType"
    },
    domProps: {
      "value": this.g_jdpayList.userType
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "userId"
    },
    domProps: {
      "value": this.g_jdpayList.userId
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "expireTime"
    },
    domProps: {
      "value": this.g_jdpayList.expireTime
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "orderType"
    },
    domProps: {
      "value": this.g_jdpayList.orderType
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "industryCategoryCode"
    },
    domProps: {
      "value": this.g_jdpayList.industryCategoryCode
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "specCardNo"
    },
    domProps: {
      "value": this.g_jdpayList.specCardNo
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "specId"
    },
    domProps: {
      "value": this.g_jdpayList.specId
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "specName"
    },
    domProps: {
      "value": this.g_jdpayList.specName
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "payChannel",
      "value": ""
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "sign"
    },
    domProps: {
      "value": this.g_jdpayList.sign
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "cert",
      "value": ""
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "vendorId",
      "value": ""
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "goodsInfo",
      "value": ""
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "orderGoodsNum",
      "value": ""
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "receiverInfo",
      "value": ""
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "termInfo",
      "value": ""
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "riskInfo",
      "value": ""
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "installmentNum",
      "value": ""
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "preProduct",
      "value": ""
    }
  }), _c('br')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09a2a730!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/payOrder/Jdpay.vue
// module id = 1414
// module chunks = 18